import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
// import { DRAWER_WIDTH } from "src/utils/constants";

export const FilterModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minWidth: "350px",
      width: "calc(100vw - 20%)",
      height: "calc(100vh - 10%)",
      position: "fixed !important" as "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      padding: "0px 0px ",
      borderRadius: "6px",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "rgb(200, 200, 200)",
      },
      [theme.breakpoints.up("md")]: {
        left: "calc(100vw - 45vw)",
        maxHeight: "calc(100vh - 10%)",
        height: "calc(100vh - 10%)",
        width: "450px",
      },
    },
    crossContainer: {
      padding: "15px 30px 0px 30px",
    },
    heading: {
      color: theme.palette.text.secondary,
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
    },
    searchBar: {
      padding: "15px 22px",
      borderRadius: "6px",
    },
    adornedStart: {
      marginRight: "5px",
    },
    itemList: {
      padding: "15px 22px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#f6eff0",
      },
    },
    item: {
      fontSize: "20px",
      linespacing: "19pt",
      fontWeight: 600,
    },

    selectorContainer: {},

    selector: {
      fontWeight: 600,
      color: "rgb(150, 150, 150)",
      padding: "10px 0px",
      cursor: "pointer",
    },

    selectorActive: {
      fontWeight: 700,
      color: theme.palette.secondary.main,
    },

    selectorActiveBorder: {
      borderBottom: "2px solid #fc4c4c",
    },
  }),
);
